/* Layers of Morocco : comportements de la page collection (facettes, tri, prix, sous-collections, vue intérieur).
   Les éléments personnalisés d'origine (facet-form, price-range, sub-collections, model-view) ne sont pas fournis par theme.js :
   ce script les remplace par des écouteurs délégués, sans dépendre des « built-in custom elements ». */
(function () {
  if (window.__layersCollection) return;
  window.__layersCollection = true;

  var timer;

  function targetUrl(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value === '' || key === 'page') return;
      params.append(key, value);
    });
    var base = (form.getAttribute('action') || window.location.pathname).split('?')[0];
    var query = params.toString();
    return query ? base + '?' + query : base;
  }

  function submit(form) {
    window.location.assign(targetUrl(form));
  }

  function bounds(wrapper) {
    var ranges = wrapper.querySelectorAll('input[type="range"]');
    var numbers = wrapper.querySelectorAll('input[type="number"]');
    return { from: ranges[0], to: ranges[1], inputFrom: numbers[0], inputTo: numbers[1], track: wrapper.querySelector('.range-wrapper') };
  }

  function paint(b) {
    if (!b.track || !b.from) return;
    var max = parseFloat(b.from.max) || 1;
    b.track.style.setProperty('--range-min', (parseFloat(b.from.value) * 100 / max).toFixed(1) + '%');
    b.track.style.setProperty('--range-max', (parseFloat(b.to.value) * 100 / max).toFixed(1) + '%');
  }

  /* Synchronise les curseurs et les champs numériques du filtre de prix */
  function syncPrice(event) {
    var wrapper = event.target.closest('price-range');
    if (!wrapper) return false;
    var b = bounds(wrapper);
    var max = parseFloat(b.from.max) || 0;
    if (event.target === b.from || event.target === b.to) {
      if (parseFloat(b.from.value) > parseFloat(b.to.value)) {
        if (event.target === b.from) b.from.value = b.to.value; else b.to.value = b.from.value;
      }
      b.inputFrom.value = parseFloat(b.from.value) > 0 ? b.from.value : '';
      b.inputTo.value = parseFloat(b.to.value) < max ? b.to.value : '';
    } else {
      b.from.value = b.inputFrom.value === '' ? 0 : b.inputFrom.value;
      b.to.value = b.inputTo.value === '' ? max : b.inputTo.value;
    }
    paint(b);
    return true;
  }

  document.addEventListener('input', function (event) {
    if (event.target.matches && event.target.matches('price-range input[type="range"]')) syncPrice(event);
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var select = target.closest('select[is="sub-collections"]');
    if (select) {
      if (select.value) window.location.assign(select.value);
      return;
    }

    var form = target.closest('form.facet-form');
    if (!form) return;
    syncPrice(event);
    window.clearTimeout(timer);
    timer = window.setTimeout(function () { submit(form); }, 350);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form.facet-form')) return;
    event.preventDefault();
    submit(form);
  });

  /* « Voir en intérieur » : bascule entre la vue produit et la vue en situation */
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('button.model-view');
    if (!button) return;
    event.preventDefault();
    var active = button.classList.toggle('is-active');
    button.querySelectorAll('.link-text').forEach(function (label) { label.classList.toggle('hidden'); });
    document.querySelectorAll('.collection .product-card__model').forEach(function (model) {
      model.classList.toggle('opacity-0', !active);
      model.classList.toggle('invisible', !active);
    });
  });
})();
